// extracted by mini-css-extract-plugin
export default {"logo":"Loader_logo__HhmHL","rotate":"Loader_rotate__rjfmf","container":"Loader_container__L10I9"};